import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { catchError, of, throwError } from 'rxjs';
import { buildSyntheticEmailSendResponse, logEmailSendHttpFailure } from './email-send-error.util';

const EMAIL_SEND_SEGMENT = '/email/send';

/**
 * Prevents /email/send failures from bubbling as HttpErrorResponse (e.g. to any global subscriber).
 * Returns a 200-shaped body so downstream code treats delivery as a non-blocking warning.
 */
export const emailSendErrorInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.includes(EMAIL_SEND_SEGMENT)) {
    return next(req);
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 || error.status === 403) {
        return throwError(() => error);
      }
      logEmailSendHttpFailure(error, 'emailSendErrorInterceptor');
      const body = buildSyntheticEmailSendResponse(error);
      return of(
        new HttpResponse({
          status: 200,
          statusText: 'OK',
          url: req.url,
          body,
        })
      );
    })
  );
};
